import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { Image } from 'react-bootstrap';
import { TodoApp } from './TodoApp';
import { HelloMessage } from './HelloMessage';
import { Game } from './tic-tac-toe';



class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <Game/>

          <Image thumbnail src={logo} className="App-logo" alt="logo" />


          <HelloMessage name="Sibugathulla" />

          <TodoApp/>

          <p >



            



          </p>


          <a
            className="App-link"
            href="https://reactjs.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn React
        </a>
        </header>
      </div>
    );
  }
}

export default App;
